<div class="decision-wrap">
  @if (status === 'approved') {
  <span class="badge badge-subtle-success">{{
    "admin.common.approved" | translate
  }}</span>
  } @else if (status === 'declined') {
  <span class="badge badge-subtle-danger">{{
    "admin.common.declined" | translate
  }}</span>
  } @else {
  <div class="icon-group">
    <app-button
      type="button"
      [btnClass]="'btn btn-danger btn-icon-square'"
      [iconClass]="'fas fa-times'"
      [ariaLabel]="'admin.common.declined' | translate"
      [loading]="isLoading()"
      [disabled]="isLoading() || !canAct()"
      (clicked)="onDecline()"
    />
    <app-button
      type="button"
      [btnClass]="'btn btn-success btn-icon-square'"
      [iconClass]="'fas fa-check'"
      [ariaLabel]="'admin.common.approved' | translate"
      [loading]="isLoading()"
      [disabled]="isLoading() || !canAct()"
      (clicked)="onApprove()"
    />
  </div>
  }
</div>
